enum outputFormats {
  'rtf' = 'rtf',
  'text' = 'text',
  'html' = 'html',
}

export default outputFormats;
